import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {Container} from 'reactstrap';
import axios from 'axios';

import { CLIENT_INFO} from '../../config';

import Sidebar from '../../components/Sidebar/';
import Footer from '../../components/Footer/';

import Register from '../../views/Register';
import Locations from '../../views/Locations';
import Dashboard from '../../views/Dashboard/';
import Tools from '../../views/Tools';
import Ads from '../../views/Ads';
import Account from '../../views/Account';
import Analytics from '../../views/Analytics';
import Update from '../../views/Update';

class Full extends Component {
  constructor(props){
    super(props);
    this.state = {
      token: null,
      client: null,
      activeLocation: 0
    }
    this.updateToken = this.updateToken.bind(this);
    this.removeToken = this.removeToken.bind(this);
    this.updateClient = this.updateClient.bind(this);
    this.updateActiveLocation = this.updateActiveLocation.bind(this);
  }

  /**
   * Removes the current authentication token from local storage
   */
  removeToken(){
    localStorage.removeItem("HC_TOKEN");
    this.setState({token: null})
  }

  /**
   * Updates token in local storage
   * @param {string} token : new token 
   */
  updateToken(token){
    if(token){
      localStorage.setItem("HC_TOKEN", token);
      this.setState({token});
    }
  }

  /**
   * Performs HTTP call to retrive and update client information
   * Logouts user if token is invalid
   */
  updateClient(){
    let token = this.state.token;
    if (!token) token = localStorage.getItem('HC_TOKEN');
    let self = this;
    axios.get(
      CLIENT_INFO(),
      {
        headers: {
          "Authorization": token,
          "Content-Type": "application/json"
        }
      }
    ).then(function(response){
      self.setState({client: response.data});
    })
    .catch(function(err){
      self.removeToken();
    })
  }

  updateActiveLocation(index){
    this.setState({activeLocation: index});
  }

  get token(){
    let token = this.state.token;
    if (token) return token;
    token = localStorage.getItem('HC_TOKEN');
    this.updateToken(token);
    return token;
  }

  render() {
    let token = this.token;
    if(token)
        return (
          <div className="app">
            <div className="app-body">
            <Sidebar {...this.props}/>
              <main className="main">
                <Container fluid>
                  <Switch>
                  <Route path="/locations" 
                      render = {() => 
                        <Locations
                          client = {this.state.client}
                          updateClient = {this.updateClient}
                          activeLocation = {this.state.activeLocation}
                          updateActiveLocation = {this.updateActiveLocation}
                        />
                      }
                    />
                    <Route path="/menu/verify" 
                      render = {() => 
                        <Dashboard
                          client = {this.state.client}
                          updateClient = {this.updateClient}
                          activeLocation = {this.state.activeLocation}
                        />
                      }
                    />
                    
                    <Route path="/menu/update" 
                      render={()=>
                        <Update 
                          client = {this.state.client}
                          updateClient = {this.updateClient}
                          activeLocation = {this.state.activeLocation}
                        />
                      }
                    /> 

                    <Route path="/analytics" 
                      render = {() => 
                        <Analytics
                          client = {this.state.client}
                          updateClient = {this.updateClient}
                          activeLocation = {this.state.activeLocation}
                          updateActiveLocation = {this.updateActiveLocation}
                        />
                      }
                    />
                    <Route path="/ads" 
                      render = {() => 
                        <Ads
                          client = {this.state.client}
                          updateClient = {this.updateClient}
                          activeLocation = {this.state.activeLocation}
                        />
                      }
                    />                    
                    <Route path="/tools" 
                      render = {() => 
                        <Tools
                          client = {this.state.client}
                          updateClient = {this.updateClient}
                          activeLocation = {this.state.activeLocation}
                        />
                      }
                    />
                    
                    <Route path="/account" 
                      render={()=>
                        <Account 
                          removeToken={this.removeToken}
                          client = {this.state.client}
                          updateClient = {this.updateClient}
                        />
                      }
                    />                   

                    <Route path="/update" 
                      render={()=>
                        <Update 
                          client = {this.state.client}
                          updateClient = {this.updateClient}
                          activeLocation = {this.state.activeLocation}
                        />
                      }
                    />                    

                    <Redirect from="/" to="/locations"/>
                  </Switch>
                </Container>
              </main>
            </div>
            <Footer />
          </div>
        );
    else
        return(
          <Register
            updateToken = {this.updateToken}
          />
        )
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js